<script>
/**
 * ****************************************************************************
 * @description     :   MainMenu
 * @created at      :   2024/05/22
 * @created by      :   trinhdt@ans-asia.com
 * @package         :   Move
 * @copyright       :   Copyright (c) A.N.S Asia
 * @version         :   1.0.0
 * ****************************************************************************
 */

/**
 * Import libraries
 */
import { mapState, mapMutations } from 'vuex';

import { MSG_TYPE } from '@/utils/messages';

/**
 * import template
 */
import template from './template.html';
import helpers from '@/utils/helpers';

/**
 * Define main layout
 */
const PtjModalMessage = {
    name: 'ModalMessage',
    template: template,
    computed: {
        ...mapState('app', ['ptjModalMessage', 'isShowPtjModalMessage']),
        showModal: {
            get() {
                return this.isShowPtjModalMessage;
            },
            set(v) {
                this.updateShowPtjModalMessage(v);
            }
        },
        showCancel() {
            const t = this.ptjModalMessage.type;
            return t === MSG_TYPE.CONFIRM || t === MSG_TYPE.CUSTOM || (t === MSG_TYPE.WARNING && this.ptjModalMessage.showBtnCancelWarning);
        },
        showTitle() {
            return this.ptjModalMessage.title && this.ptjModalMessage.title !== '';
        },
        headerTitle() {
            if (this.showTitle) return this.ptjModalMessage.title;
            const t = this.ptjModalMessage.type;
            if (t === MSG_TYPE.CONFIRM || t === MSG_TYPE.CUSTOM) return '確認';
            if (t === MSG_TYPE.SUCCESS) return '申請完了';
            if (t === MSG_TYPE.ERROR) return 'エラー';
            if (t === MSG_TYPE.WARNING) return '警告';
            return '';
        },
        iconClass() {
            const t = this.ptjModalMessage.type;
            return {
                'is-confirm': t === MSG_TYPE.CONFIRM || t === MSG_TYPE.CUSTOM,
                'is-success': t === MSG_TYPE.SUCCESS,
                'is-error': t === MSG_TYPE.ERROR,
                'is-warning': t === MSG_TYPE.WARNING
            };
        },
        msgType() {
            return MSG_TYPE;
        },
        dialogStyle() {
            return this.hasMoved ? { top: this.posY + 'px', left: this.posX + 'px' } : {};
        }
    },
    data() {
        return {
            lastWidth: 0,
            lastHeight: 0,
            // drag state
            isDragging: false,
            hasMoved: false,
            dragOffsetX: 0,
            dragOffsetY: 0,
            posX: 0,
            posY: 0,
            isiOS: helpers.getMobileOperatingSystem() == 'iOS'
        };
    },
    mounted() {
        this.lastWidth = window.innerWidth;
        this.lastHeight = window.innerHeight;
        // this.$watch(
        //     () => this.showModal,
        //     (v) => {
        //         if (v) this.focusDefault();
        //     },
        //     { immediate: true }
        // );
        window.addEventListener('mousemove', this.onMove);
        window.addEventListener('mouseup', this.onUp);
    },
    beforeUnmount() {
        window.removeEventListener('mousemove', this.onMove);
        window.removeEventListener('mouseup', this.onUp);
    },
    methods: {
        ...mapMutations('app', ['hidePtjModalMessage', 'updateShowPtjModalMessage']),
        onClickOk() {
            const cb = this.ptjModalMessage.callback;
            this.hidePtjModalMessage();
            if (cb) setTimeout(() => cb(true), 0);
        },
        onClickCancel() {
            const cb = this.ptjModalMessage.callbackCancel;
            this.hidePtjModalMessage();
            if (cb) setTimeout(() => cb(true), 0);
        },
        shake() {
            const el = this.$refs.dialog;
            el.classList.add('shake');
            setTimeout(() => el.classList.remove('shake'), 200);
        },
        focusDefault() {
            const isManager = localStorage.getItem('mode') == 1;
            this.$nextTick(() => {
                const el = isManager ? this.$refs.btnOk : this.$refs.btnCancel || this.$refs.btnOk;
                el && el.focus();
            });
        },
        onHeaderDown(e) {
            const rect = this.$refs.dialog.getBoundingClientRect();
            this.isDragging = true;
            this.hasMoved = true;
            this.dragOffsetX = e.clientX - rect.left;
            this.dragOffsetY = e.clientY - rect.top;
            this.posX = rect.left;
            this.posY = rect.top;
        },
        onMove(e) {
            if (!this.isDragging) return;
            const vw = window.innerWidth;
            const vh = window.innerHeight;
            const rect = this.$refs.dialog.getBoundingClientRect();
            const w = rect.width,
                h = rect.height;
            let nextLeft = e.clientX - this.dragOffsetX;
            let nextTop = e.clientY - this.dragOffsetY;
            // clamp
            const margin = 8;
            nextLeft = Math.min(Math.max(margin, nextLeft), vw - w - margin);
            nextTop = Math.min(Math.max(margin, nextTop), vh - h - margin);
            this.posX = nextLeft;
            this.posY = nextTop;
        },
        onUp() {
            this.isDragging = false;
        }
    }
};
export default PtjModalMessage;
</script>
